import { Box, Button, Checkbox, Divider, Stack, TextField, Typography } from '@montugroup/design-system';
import { FormControlLabel, styled } from '@mui/material';

export const Content = styled(Stack)(({ theme }) => ({
  margin: 'auto 0',
  maxWidth: '680px',
  padding: theme.spacing(0, 6, 24),

  [theme.breakpoints.up('sm')]: {
    margin: `${theme.spacing(36)} auto 0`,
  },

  [theme.breakpoints.up('md')]: {
    margin: `${theme.spacing(28)} auto 0`,
    padding: theme.spacing(0, 0, 24),
  },

  [theme.breakpoints.up('lg')]: {
    margin: `${theme.spacing(24)} auto 0`,
  },
}));

export const LogoContainerMobile = styled(Box)(({ theme }) => ({
  display: 'block',
  marginBottom: theme.spacing(4),

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.up('sm')]: {
    display: 'block',
    marginBottom: theme.spacing(12),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(7),
  color: theme.palette.primary.main,
}));

export const PreHeading = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(3),
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.secondary.main,
  letterSpacing: theme.spacing(0.25),
  textTransform: 'uppercase',
}));

export const Heading = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(5),
  fontWeight: theme.typography.fontWeightBold,
}));

export const Text = styled(Typography)({
  lineHeight: 1.6,
});

export const MandatoryText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const FieldsContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
}));

export const HalfWidthFieldsContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(4),

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const HalfWidthField = styled(TextField)({
  flex: 1,
});

export const SectionDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(8, 0),
}));

export const CheckboxContainer = styled(FormControlLabel)(({ theme }) => ({
  alignItems: 'flex-start',
  gap: theme.spacing(3),
  margin: 0,
  padding: theme.spacing(4),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,

  [theme.breakpoints.up('sm')]: {
    alignItems: 'center',
  },
}));

export const CheckField = styled(Checkbox)(({ theme }) => ({
  padding: theme.spacing(0),
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(4.5, 8)} !important`,
}));
